// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__VfUu8","content":"styles_content__1q8l7","checkbox":"styles_checkbox__27qde","checkboxLabel":"styles_checkboxLabel__2zzXD"};